import { cn } from "@/utils/cssHelpers";
import React, { ReactNode } from "react";

export type StatusBoxProps = {
  icon: ReactNode;
  title: ReactNode;
  value: number;
  className?: string;
};
const StatusBox = ({ icon, title, value, className }: StatusBoxProps) => {
  return (
    <div
      className={cn("shadow rounded bg-white p-8 flex justify-center items-center w-64", className)}
    >
      <div className='flex justify-center items-center space-x-5'>
        <div>{icon}</div>
        <div className='flex flex-col justify-center items-start space-y-4'>
          <span className='text-sm text-mid-neutral-1'>{title}</span>
          <span className='font-bold text-lg font-sans-serif text-deep-blue'>{value}</span>
        </div>
      </div>
    </div>
  );
};

export default StatusBox;
